import SchedulerModelBase from '../_generated/modelBases/scheduler-model-base';

export default class SchedulerModel extends SchedulerModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
